import DatePicker from "@/components/ui/date-picker";
import SimpleSelect from "@/components/ui/simple-select";
import React, { useState } from "react";

const DomainDatePicker = ({
  rule,
  handleChange,
  includeTime = true,
}: {
  rule: any;
  handleChange: (value: any) => void;
  includeTime?: boolean;
}) => {
  const [dateType, setDateType] = useState(
    rule.value &&
      typeof rule.value === "string" &&
      (rule.value?.startsWith("@@") || rule.value?.startsWith("!!"))
      ? "relative"
      : "fixed"
  );

  return (
    <div className="flex flex-row gap-2">
      <SimpleSelect
        value={dateType}
        onChange={(value) => {
          handleChange(value === "fixed" ? "" : "@@today");
          setDateType(value);
        }}
        options={[
          { value: "fixed", label: "Fixed" },
          { value: "relative", label: "Relative" },
        ]}
        className="w-32"
      />
      {dateType === "fixed" ? (
        <DatePicker
          value={rule.value || ""}
          onChange={(value) => handleChange(value)}
          placeholder={includeTime ? "Select date & time" : "Select date"}
          includeTime={includeTime}
          className="flex-1"
        />
      ) : (
        <SimpleSelect
          value={rule.value}
          placeholder={"Select relative date"}
          onChange={(value) => handleChange(value)}
          options={
            includeTime
              ? [
                  ...(rule.operator === "="
                    ? [
                        { value: "!!today", label: "Today" },
                        { value: "!!this_week", label: "This week" },
                        { value: "!!this_month", label: "This month" },
                        { value: "!!this_quarter", label: "This quarter" },
                        { value: "!!this_year", label: "This year" },
                      ]
                    : [
                        { value: "@@now", label: "Now" },
                        { value: "@@start_of_today", label: "Start of today" },
                        { value: "@@end_of_today", label: "End of today" },
                        { value: "@@start_of_week", label: "Start of week" },
                        { value: "@@end_of_week", label: "End of week" },
                        { value: "@@start_of_month", label: "Start of month" },
                        { value: "@@end_of_month", label: "End of month" },
                        { value: "@@start_of_year", label: "Start of year" },
                        { value: "@@end_of_year", label: "End of year" },
                        {
                          value: "@@start_of_quarter",
                          label: "Start of quarter",
                        },
                        { value: "@@end_of_quarter", label: "End of quarter" },
                      ]),
                ]
              : [
                  { value: "@@today", label: "Today" },
                  { value: "@@yesterday", label: "Yesterday" },
                  { value: "@@first_of_week", label: "First day of week" },
                  { value: "@@last_of_week", label: "Last day of week" },
                  { value: "@@first_of_month", label: "First day of month" },
                  { value: "@@last_of_month", label: "Last day of month" },
                  { value: "@@first_of_year", label: "First day of year" },
                  { value: "@@last_of_year", label: "Last day of year" },
                  {
                    value: "@@first_of_quarter",
                    label: "First day of quarter",
                  },
                  { value: "@@last_of_quarter", label: "Last day of quarter" },
                ]
          }
          className="flex-1"
        />
      )}
    </div>
  );
};

export default DomainDatePicker;
